import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';
import { HttpHelper } from '../shared/http-helper';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class AdminService {
  users: any
  roles: any
  

    constructor(private httpHelper: HttpHelper) {}


    //Do we need a user types?????
    getUsers() : Observable<any> {
        //wasn't able to get cacheing to work but found a couple of examples
        //this really isn't pulling back that much data so just going to run the call again
        return this.httpHelper.get('api/users');
    }

    getRoles() : Observable<any> {
        return this.httpHelper.get('auth/api/account/roles');		
	}

    //This seems to be never used
    getCachedUsers(){
	    return this.users;
	}


    //so will have an user interface but not sure if I will need it here
    createUser(user: any): Observable<any>{
        return this.httpHelper.post(
            //'auth/api/users/',
            'api/users/', 
            JSON.stringify(user));
        //TODO: test error handling here
    }

    emailExists(email: string): Observable<any>{
        return this.httpHelper.post(
            'auth/api/account/emailexists', 
            //this might not be right
            JSON.stringify({email: email}));
	}

    usernameExists(username: string): Observable<any>{
        return this.httpHelper.post(
            'auth/api/account/usernameexists', 
            //this might not be right
            JSON.stringify({username: username}));
	}

    updateUser(user: any): Observable<any>{
        return this.httpHelper.put(
            'api/users/' + user.id, 
            JSON.stringify(user));
	}

    deleteUser(userid: string): Observable<any>{
        return this.httpHelper.delete('api/users/' + userid);
	}
	
}


/** WEBPACK FOOTER **
 ** ./app/administration/admin.service.ts
 **/